import React, { useState, useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import '../App.css';
import MyStorage from './util/storage';
import Api from './api/api'

const MySidebar = ({ }) => {
    const [activeIndex, setActiveIndex] = useState(100);

    const logoutUser = () => {
        console.log('logoutUser');
        // let user = MyStorage.getUser()
        MyStorage.setUser(null)
        // Api.logoutUser(user.id,
        //     (response) => {
        //         //
        //     },
        //     (error) => {
        //         //
        //     });
    };

    // check session
    if (!MyStorage.isLogin()) {
        return <Navigate to='/admin/login' replace />;
    }

    return (
        <div>
            <div style={{ height: '90vh', width: 200, display: 'flex', flexDirection: 'column', backgroundColor: 'black', paddingTop: 5 }}>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/lectures',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(3)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 3 ? 'gray' : 'black' }}>
                        Chapters
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/cases',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(322)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 322 ? 'gray' : 'black' }}>
                        Case Scenarios
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/quiz-list',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(545)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 545 ? 'gray' : 'black' }}>
                        Quiz
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/fracture-quiz-list',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(546)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 546 ? 'gray' : 'black' }}>
                        Fracture Quiz
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/illustrations',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(547)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 547 ? 'gray' : 'black' }}>
                        Illustrations
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/drug-refs',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(543)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 543 ? 'gray' : 'black' }}>
                        Drug References
                    </div>
                </Link>

                <Link
                    style={{ textDecoration: 'none' }}
                    to={{
                        pathname: '/admin/contact',
                    }}>
                    <div
                        onClick={() => {
                            setActiveIndex(101)
                        }}
                        className='menu-item'
                        style={{ backgroundColor: activeIndex === 101 ? 'gray' : 'black' }}>
                        Contact Info
                    </div>
                </Link>


                <div
                    onClick={() => {
                        logoutUser()
                        setActiveIndex(4)
                    }}
                    className='menu-item'
                    style={{ backgroundColor: activeIndex === 4 ? 'gray' : 'black', display: 'flex', alignItems: 'center' }}>
                    Logout
                </div>

            </div>
        </div>
    );
}

export default MySidebar;
